import axios from "axios";
import { environment } from "environments/environment";
import { UserInterface } from "../intrefaces/users/user.interface";
import { SaveUserInterface } from "../intrefaces/users/save-user.interface";

export const UserService = {
    async get() {
        const result = await axios.get<UserInterface>(environment.urls.user);
        return result.data;
    },

    async me() {
        const result = await axios.get<{ name: string }>(environment.urls.me);
        return result.data;
    },

    async save(user: SaveUserInterface) {
        const result = await axios.post<UserInterface>(environment.urls.userSave, user);
        return result.data;
    },

    async validEmail(email: string) {
        const result = await axios.post<{ isValid: boolean }>(environment.urls.validEmail, { email })
        return result.data;
    }
}